var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-8" },
      [
        _c("pagination", {
          attrs: { data: _vm.records, limit: 3 },
          on: { "pagination-change-page": _vm.getRecords }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.records.total
      ? _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "pull-right" }, [
            _c(
              "select",
              {
                staticClass: "form-control",
                attrs: { name: "page_length" },
                domProps: { value: _vm.pageLength },
                on: { change: _vm.updateValue }
              },
              _vm._l(_vm.getConfig("pagination"), function(option) {
                return _c("option", { domProps: { value: option } }, [
                  _vm._v(
                    "\n\t\t\t        " +
                      _vm._s(option + " " + _vm.trans("general.per_page")) +
                      "\n\t\t\t      "
                  )
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }